import styled from 'styled-components';

import * as MUI from '@mui/material';
import { Theme } from '../Theme';

export const TableContainer = styled(MUI.TableContainer)`
	height: ${(props) => (props.height ? props.height : 'calc(100vh - 14.5rem)')} !important;
	min-width: ${(props) => (props.width ? props.width : '1200px')} !important;
	overflow: overlay;
	scrollbar-width: thin;
	scrollbar-color: #c4c4c4 #ffffff00;
`;

export const Table = styled(MUI.Table)``;

export const TableHeader = styled(MUI.TableHead)`
	position: sticky !important;
	top: 0 !important;
	z-index: 100 !important;
`;

export const TableBody = styled(MUI.TableBody)``;

export const TableRow = styled(MUI.TableRow)`
	background-color: ${Theme.white} !important;
	&:hover {
		background: ${Theme.lightWhite} !important;
		cursor: pointer;
	}
`;

export const TableHeaderRow = styled(TableRow)`
	background-color: ${Theme.creamWhite} !important;
`;

export const TableColumn = styled(MUI.TableCell)`
	padding: 1rem 0.5rem 1rem 0.5rem !important;
	margin: 0 !important;
	vertical-align: top !important;
	width: ${(props) => props.width || ''};
	min-width: ${(props) => props.minWidth || null};
	max-width: ${(props) => props.maxWidth || null};
	text-align: ${(props) => {
		if (props.alignLeft) {
			return 'left';
		} else if (props.alignRight) {
			return 'right';
		} else if (props.alignCenter) {
			return 'center';
		} else {
			return 'left';
		}
	}} !important;
	font-family: Arial !important;
	line-height: 14px !important;
	font-weight: 600 !important;
	font-size: 14px !important;
	border-bottom-width: 0.5px !important;

	&:first-child {
		padding-left: 2rem !important;
	}
	&:last-child {
		padding-right: 2rem !important;
	}
`;

export const TableHeaderColumn = styled(TableColumn)`
	padding: 1rem 0.5rem 1rem 0.5rem !important;
	margin: 0 !important;
	color: ${Theme.darkGrey} !important;
	font-size: 11px !important;
	text-transform: uppercase !important;
	border-width: 0 !important;
	align-self: center !important;
`;

export const TablePagination = styled(MUI.TablePagination)``;
